import React, { memo } from "react";

import { PL_BILL_PRIMITIVES_TEST_IDS } from "@swiggy-private/cart-test-ids";

import { ShimmerSweep, ShimmerBand } from "../../../pl-bill-free-text/BillFreeText.style";

const TextShimmer = () => (
    <ShimmerSweep aria-hidden="true" data-testid={PL_BILL_PRIMITIVES_TEST_IDS.SHIMMER}>
        <ShimmerBand bandWidth="10px" />
        <ShimmerBand bandWidth="6px" />
    </ShimmerSweep>
);

export default memo(TextShimmer);
